import type { FC, ReactNode } from 'react'

import MainContainer from '@/components/generals/main-container'
import EditorialGrid from '@/components/generals/editorial-grid'
import Button from '@/components/elements/button'
import { EditableLink } from '@/components/elements/editable'
import { profile } from '@/constants/profile'

const ContactCta: FC = (): ReactNode => {
    return (
        <section id='contact' aria-labelledby='contact-title' className='tone-sienna'>
            <MainContainer className='py-20 md:py-32'>
                <p className='flex items-center gap-3 font-mono text-label uppercase text-muted-foreground'>
                    <span aria-hidden='true' className='size-1.5 bg-foreground' />
                    <span className='text-foreground'>05</span>
                    Contact
                </p>

                <h2 id='contact-title' className='mt-10 max-w-[20ch] font-heading text-headline [font-weight:380] md:mt-14'>
                    Have an interesting idea? <em>Let&apos;s build something useful.</em>
                </h2>

                <EditorialGrid className='mt-12 gap-y-10 md:mt-16'>
                    <div className='col-span-4 flex flex-col gap-6 md:col-span-6'>
                        <p className='max-w-[44ch] text-lede'>
                            Projects, collaborations, a question about an article, or a note about something that broke.
                            A few lines are enough to start.
                        </p>

                        <Button href='/contact' size='lg' icon='arrow' className='self-start'>
                            Start a conversation
                        </Button>
                    </div>

                    <div className='col-span-4 md:col-span-5 md:col-start-8 md:self-end'>
                        <p className='font-mono text-label uppercase text-muted-foreground'>Or find me at</p>

                        <ul className='mt-4 flex flex-col border-t border-border text-[0.9375rem]'>
                            <li className='flex items-center justify-between gap-4 border-b border-border py-3'>
                                <span className='font-mono text-label uppercase text-muted-foreground'>Email</span>
                                <EditableLink href={profile.email} label={profile.email} />
                            </li>
                            <li className='flex items-center justify-between gap-4 border-b border-border py-3'>
                                <span className='font-mono text-label uppercase text-muted-foreground'>GitHub</span>
                                <EditableLink href={profile.links.github} label='GitHub profile' />
                            </li>
                            <li className='flex items-center justify-between gap-4 border-b border-border py-3'>
                                <span className='font-mono text-label uppercase text-muted-foreground'>LinkedIn</span>
                                <EditableLink href={profile.links.linkedin} label='LinkedIn profile' />
                            </li>
                        </ul>
                    </div>
                </EditorialGrid>
            </MainContainer>
        </section>
    )
}

export default ContactCta
